/*
 * @Author: hai.zhang
 * @LastEditors: Please set LastEditors
 * @Date: 2019-08-21 16:54:08
 * @LastEditTime: 2023-03-27 16:56:55
 */
import response from 'fe-coms/utils/response'
import Api from './api'
import {setUser} from 'fe-coms/components/business/paas/store/local-catch/user'
// import versionCheck from 'fe-coms/utils/version-check/index.js'
/* global Vue */

const $http = Vue.prototype.$http
const pureRequest = Vue.prototype.pureRequest
const anHour = 30 * 60 * 1000
export function getAuth (store, router) {
  // router.afterEach(async (to, from) => {
  //   versionCheck()
  // })
  router.beforeEach(async (to, from, next) => {
    // 如果含有打开默认浏览器标识直接跳转到打开默认浏览器页面
    const isOpenBrowser = document.cookie.includes('T_T') && to.name !== 'avoid-login'
    if (isOpenBrowser) {
      next({path: '/avoid/login'})
      return
    }
    // 判断租户portal配置
    const isBreak = await initPortalConfig(store, to, next)
    if (isBreak) {
      return
    }
    await store.dispatch('checkAuthInit')
    const fe = window.fe || {}
    to.path !== from.path && (fe.pageTime = new Date().getTime() + '' + parseInt(Math.random() * 1e4))
    window.fe.requestCached = {}
    window.fe.fixedBottom = []
    window.store = store
    const loginCheck = store.state.checkAuth.pageList.includes(to.name)
    if (!loginCheck) {
      await getUserInfo(store, next, to)
    } else {
      next()
    }
  })
  router.beforeResolve(async (to, from, next) => {
    await getPageText(store, to)
    next()
  })
}
// 获取用户信息
async function getUserInfo (store, next, to) {
  const api = Api.getLoginUser
  const res = await response($http(api.type, api.url, {}, {}, { isCache: true, timeInterval: anHour }), {
    showError: false,
    authError: true,
    tokeInvalidError: false
  })
  if (res.isOk) {
    // console.log(res)
    const data = res.content || {}
    data.loginStatus = true
    setUser(data)
    store.commit('SET_USERINFO', data || {})
    // store.commit('setUserInfo', data)
    next()
  } else {
    if (res.code === 'INVALID_TOKEN') {
      document.getElementById('commonWord').value = res.content
      next()
    }
    if (process.env.NODE_ENV === 'development') {
      next()
    }
  }
}
/* global IS_DEV */

async function getPageText (store, to) {
  const fe = window.fe
  const meta = to.meta || {}
  const code = meta.i18nCode ? meta.i18nCode : to.name
  const noTranslation = meta.noTranslation
  let pageText = {}
  if (code && !noTranslation) {
    try {
      if (IS_DEV) {
        pageText = require(`../../../../i18n/${code}/${fe.language}.json`)
        console.log(pageText)
      } else {
        const res = await pureRequest('get', fe.staticUrl  + `/fe-${fe.project}/i18n/${code}/${fe.language}.json`, {}, {}, { isCache: true, timeInterval: anHour })
        if (res) {
          pageText = res.data
        }
      }
      // const res = await axios.get(fe.i18nOssHost + `${fe.project}/${code}/${fe.language}.json`)
      // const response = await axios.get(fe.i18nOssHost + `/purchaser/login/zh-CN.json`)
      // console.log(response)
    } catch (e) {
      console.error(e)
      console.log('请求失败')
    }
  }
  store.commit('SET_PAGE_TEXT', pageText)
}

// 登录跳转配置
async function initPortalConfig (store, to, next) {
  let isBreak = false
  const api = Api.portalConfig
  const res = await response($http(api.type, api.url))
  if (res.isOk) {
    const domains = res.content.pcDomain
    const configs = res.content.tenantPortals || []
    const item = configs.find(item => item.defaultOpen)
    store.commit('SET_PORTAL_CODE', item.code)
    if (item.code !== 'mall' && to.name === 'main') {
      isBreak = true
      if (item.code === 'demandPortal') {
        next({path: '/portal'})
      }
      if (item.code === 'purchasePortal') {
        window.location.href = `//${domains}${item.indexUrl}`
      }
    }
  }
  return isBreak
}
